{
  "back": "Wróć",
  "backToList": "Powrót do listy",
  "add": "Dodaj",
  "cancel": "Anuluj",
  "delete": "Usuń",
  "addFile": "Dodaj plik",
  "save": "Zapisz",
  "saveDraft": "Zapisz roboczo",
  "selectAll": "Zaznacz wszystkie",
  "validate": "Sprawdź",
  "view": "Podgląd",
  "edit": "Edytuj",
  "download": "Pobierz",
  "expand": "Rozwiń",
  "collapse": "Zwiń",
  "accept": "Zaakceptuj",
  "withdrawAcceptance": "Wycofaj akceptację"
}
